import Axios from "./interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/api/CommandCenter";

const getAllTiles = async () => {
  const response = await Axios.get(API_URL + `/GetCommandCenterTiles`);
  return response;
};

const addTile = async (data) => {
  const response = await Axios
    .post(API_URL + "/AddCommandCenterTile", data);
  return response;
};

const updateTile = async (data) => {
  const response = await Axios
    .post(API_URL + "/UpdateCommandCenterTile", data);
  return response;
};

const deleteTile = async (tileId) => {
  const response = await Axios.post(API_URL + "/DeleteCommandCenterTile", tileId);
  return response;
};

export default {
  getAllTiles,
  addTile,
  updateTile,
  deleteTile,
};